<template>
  <button @click="goBack" class="flex items-center btn">
    <Icon name="back-arrow" :size="24" color="#C2C3C4" />
    Back
  </button>
</template>

<script setup lang="ts">
import Icon from './Icon.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const goBack = () => {
  const hasBackState = router.options.history?.state?.back
  if (hasBackState) {
    router.back()
  } else {
    router.push('/')
  }
}
</script>

<style scoped>
.btn {
  gap: 10px;
  /* margin-bottom: 30px; */
  background-color: transparent;
  color: #c2c3c4;
  font-size: 14px;
  padding: 0;
  font-weight: 600;
}
</style>
